import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "",
  style: {}
}
const _hoisted_3 = {
  class: "centered w100",
  style: {"padding-top":"10px"}
}
const _hoisted_4 = {
  class: "fl pad40 posFi",
  style: {"margin-left":"200px"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fs14 fw600" }, "質問を追加", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb20" }, null, -1)
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "fs14 fw600 mt10"
}
const _hoisted_10 = {
  key: 1,
  class: "fs14 fw600 mt10"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb20" }, null, -1)
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "fs14 fw600 mt10" }, "その他フォーム設定", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb20" }, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "fr with_white_bg mr20",
  style: {"width":"800px"}
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", {
  class: "fw600 fl",
  style: {"margin-bottom":"0","margin-left":"-3px"}
}, "  公開ページのフォームを読み込む ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = {
  key: 1,
  class: "w100"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "text-left mt20" }
const _hoisted_26 = {
  key: 0,
  class: "fl"
}
const _hoisted_27 = {
  key: 0,
  class: "fl"
}
const _hoisted_28 = ["href"]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  class: "fl"
}
const _hoisted_31 = ["href"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 1,
  class: "fl"
}
const _hoisted_34 = {
  key: 0,
  class: "fl"
}
const _hoisted_35 = ["href"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  key: 1,
  class: "fl"
}
const _hoisted_38 = ["href"]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = {
  key: 2,
  class: "pointer fl dgrey"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "fl" }, "に同意し、", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = {
  key: 1,
  class: "fr with_white_bg mr20",
  style: {"width":"800px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormFieldContent = _resolveComponent("FormFieldContent")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_ConditionSettings = _resolveComponent("ConditionSettings")!
  const _component_SearchRoomModal = _resolveComponent("SearchRoomModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.rcm && _ctx.rcm.room)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                style: { width: `120px`, height: `120px` },
                class: "pointer hoverLgreyBg rad8 pad10",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addNewField(_ctx.fields.length - 1)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/round_plus.png`),
                  width: "80",
                  height: "80"
                }, null, 8, _hoisted_5),
                _hoisted_6
              ]),
              _hoisted_7,
              (_ctx.viewFrom == `aform`)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "pointer hoverLgreyBg rad8 pad10",
                    style: { width: `120px`, height: `120px` },
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editConditions && _ctx.editConditions(...args)))
                  }, [
                    _createElementVNode("img", {
                      class: "ml5",
                      src: _ctx.$getAssetImageUrl(`/assets/icons/form_assign.png`),
                      width: "60",
                      height: "60"
                    }, null, 8, _hoisted_8),
                    (_ctx.selectedTabName == `list`)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, "振り分け設定"))
                      : _createCommentVNode("", true),
                    (_ctx.selectedTabName == `conditions`)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, "フォーム項目設定"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_11,
              _createElementVNode("div", {
                class: "pointer hoverLgreyBg rad8 pad10",
                style: { width: `120px`, height: `120px` },
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.editTOSPP && _ctx.editTOSPP(...args)))
              }, [
                _createElementVNode("img", {
                  class: "ml5",
                  src: _ctx.$getAssetImageUrl(`/assets/icons/form_green.png`),
                  width: "60",
                  height: "60"
                }, null, 8, _hoisted_12),
                _hoisted_13
              ]),
              _hoisted_14
            ]),
            (_ctx.selectedTabName == `list`)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("section", {
                    class: _normalizeClass(`mt40 rad8 kakugo with_white_bg ${_ctx.isSP ? 'pad20' : 'pad40'}`)
                  }, [
                    (_ctx.viewFrom == `aform`)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("label", {
                            class: _normalizeClass(`circle_button fw400 fr centered fs12 blueAround`),
                            style: {"width":"250px","padding":"4px 10px","margin-left":"30px","margin-top":"-5px","border":"0"},
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openSearchRoomModal && _ctx.openSearchRoomModal(...args)))
                          }, [
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/select_file.png`),
                              width: "18",
                              height: "23",
                              style: {"margin-top":"-2px"},
                              class: "fl"
                            }, null, 8, _hoisted_17),
                            _hoisted_18
                          ]),
                          _hoisted_19
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.fields)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createVNode(_component_draggable, {
                            modelValue: _ctx.fields,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.fields) = $event)),
                            "item-key": `id`,
                            group: "fieldsGroup",
                            onStart: _cache[5] || (_cache[5] = ($event: any) => (_ctx.drag = true)),
                            onEnd: _ctx.sortEnd
                          }, {
                            item: _withCtx(({ element: field, index: fieldindex }) => [
                              (_openBlock(), _createElementBlock("div", {
                                class: "w100",
                                key: `${fieldindex}${_ctx.systemUpdatedAt}`
                              }, [
                                (
                                                _ctx.rcm.room_setting &&
                                                _ctx.rcm.room_setting.send_channel_type == `sms` &&
                                                field.param_key == `attendee1_email`
                                            )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21))
                                  : (_openBlock(), _createBlock(_component_FormFieldContent, {
                                      key: 1,
                                      field: field,
                                      fieldindex: fieldindex,
                                      total: _ctx.fields.length,
                                      editable: true,
                                      onUpdateField: _ctx.updateFieldFromChild,
                                      onEditField: _ctx.editField,
                                      onRemoveField: _ctx.removeField,
                                      onCopyField: _ctx.copyField,
                                      onClickUp: _ctx.clickUp,
                                      onClickDown: _ctx.clickDown,
                                      onAddNewField: _ctx.addNewField
                                    }, null, 8, ["field", "fieldindex", "total", "onUpdateField", "onEditField", "onRemoveField", "onCopyField", "onClickUp", "onClickDown", "onAddNewField"])),
                                _hoisted_22
                              ]))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onEnd"])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_23,
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, [
                      (!_ctx.noShowAny())
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "editableTOSPP withEditable posRe",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.editTOSPP && _ctx.editTOSPP(...args)))
                          }, [
                            (_ctx.Util.isPresent(_ctx.fcm.aform))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  (_ctx.hasTos())
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        _createElementVNode("a", {
                                          href: `${_ctx.fcm.aform.terms_of_service_url}`,
                                          target: "_blank",
                                          class: "dgrey"
                                        }, [
                                          _createTextVNode(_toDisplayString(_ctx.tosName()) + " ", 1),
                                          (_ctx.hasPP() || _ctx.showWaaqTos())
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, "・"))
                                            : _createCommentVNode("", true)
                                        ], 8, _hoisted_28)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.hasPP())
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                        _createElementVNode("a", {
                                          href: `${_ctx.fcm.aform.privacy_policy_url}`,
                                          target: "_blank",
                                          class: "dgrey"
                                        }, [
                                          _createTextVNode(_toDisplayString(_ctx.ppName()), 1),
                                          (_ctx.showWaaqTos())
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, "・"))
                                            : _createCommentVNode("", true)
                                        ], 8, _hoisted_31)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.Util.isPresent(_ctx.rcm.room_setting))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    (_ctx.hasTos())
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                          _createElementVNode("a", {
                                            href: `${_ctx.rcm.room_setting.terms_of_service_url}`,
                                            target: "_blank",
                                            class: "dgrey"
                                          }, [
                                            _createTextVNode(_toDisplayString(_ctx.tosName()), 1),
                                            (_ctx.hasPP() || _ctx.showWaaqTos())
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_36, "・"))
                                              : _createCommentVNode("", true)
                                          ], 8, _hoisted_35)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.hasPP())
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                          _createElementVNode("a", {
                                            href: `${_ctx.rcm.room_setting.privacy_policy_url}`,
                                            target: "_blank",
                                            class: "dgrey"
                                          }, [
                                            _createTextVNode(_toDisplayString(_ctx.ppName()), 1),
                                            (_ctx.showWaaqTos())
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_39, "・"))
                                              : _createCommentVNode("", true)
                                          ], 8, _hoisted_38)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                            (_ctx.showWaaqTos())
                              ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.hasTos() || _ctx.hasPP() ? `waaq` : ``) + "利用規約・" + _toDisplayString(_ctx.hasTos() || _ctx.hasPP() ? `waaq` : ``) + "プライバシーポリシー ", 1))
                              : _createCommentVNode("", true),
                            _hoisted_41
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_42,
                    _createElementVNode("div", {
                      class: _normalizeClass(`w100 rad6 mt10 fs16 fw600 mb20 pointer ${_ctx.buttonBgColor() ? `` : `pinkBg`}`),
                      style: _normalizeStyle({
                                width: `100%`,
                                height: `52px`,
                                lineHeight: `52px`,
                                backgroundColor: _ctx.buttonBgColor() || null,
                                color: _ctx.buttonTextColor() || null,
                            })
                    }, _toDisplayString(_ctx.formSubmitButtonName()), 7),
                    _hoisted_43,
                    _hoisted_44
                  ], 2)
                ]))
              : (_ctx.selectedTabName == `conditions`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _createVNode(_component_ConditionSettings)
                  ]))
                : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_SearchRoomModal)
  ]))
}